"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title2 = exports.Title1 = void 0;
var react_1 = __importDefault(require("react"));
require("./index.less");
/**
 * 标题一
 * @param props
 * @returns
 */
function Title1(props) {
    return (react_1.default.createElement("div", { className: "title1", style: props.mt ? { marginTop: props.mt } : {} }, props.children));
}
exports.Title1 = Title1;
Title1.Main = function (props) {
    return react_1.default.createElement("div", { className: "t" }, props.children);
};
Title1.More = function (props) {
    return react_1.default.createElement("div", { className: "more" }, props.children);
};
/**
 * 标题二
 * @param props
 * @returns
 */
function Title2(props) {
    return (react_1.default.createElement("div", { className: "title2" }, props.children));
}
exports.Title2 = Title2;
Title2.Main = function (props) {
    return react_1.default.createElement("div", { className: "t" }, props.children);
};
Title2.More = function (props) {
    return react_1.default.createElement("div", { className: "more" }, props.children);
};
